import React, { useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { VerticalFlex } from 'smartsuite-ui/lib/containers/VerticalFlex';
import WidgetEditor from './WidgetEditor';
import WidgetLibrary from './WidgetLibrary';
import { editorTabs } from '../shared/constants/constants';
import EditorTabs from './EditorTabs';
import EditorDrawerRail from './EditorDrawerRail';
import useDeleteWidget from '../shared/hooks/useDeleteWidget';

// eslint-disable-next-line complexity
export default function EditorDrawer(props) {
    const { deleteWidget } = props;
    const [selectOptions, setSelectOptions] = useState([]);
    const [
        incorrectlyConfiguredDashboards,
        setIncorrectlyConfiguredDashboards,
    ] = useState({});

    useDeleteWidget(props.deleteWidget);

    function renderWidgetEditor() {
        if (
            props.activeTab !== editorTabs.editWidget ||
            isEmpty(props.selectedWidget)
        ) {
            return null;
        }

        return (
            <WidgetEditor
                dashboardTimeAndPrecision={props.dashboardTimeAndPrecision}
                deleteWidget={deleteWidget}
                incorrectlyConfiguredDashboards={
                    incorrectlyConfiguredDashboards
                }
                selectOptions={selectOptions}
                selectedWidget={props.selectedWidget}
                setErrorWidgetIds={props.setErrorWidgetIds}
                setSelectOptions={setSelectOptions}
                setIncorrectlyConfiguredDashboards={
                    setIncorrectlyConfiguredDashboards
                }
                updateWidget={props.updateWidget}
            />
        );
    }

    const drawerClass = props.drawerCollapsed
        ? 'editor-drawer editor-drawer--hidden'
        : 'editor-drawer';

    return (
        <div className={drawerClass}>
            <div className="editor-drawer__container">
                <EditorDrawerRail toggleDrawer={props.toggleDrawer} />
                <VerticalFlex cssClassModifiers={['is-full']}>
                    <EditorTabs
                        activeTab={props.activeTab}
                        selectedWidget={props.selectedWidget}
                        setActiveTab={props.setActiveTab}
                    />
                    <div className="editor-drawer__content">
                        <WidgetLibrary
                            availableWidgets={props.availableWidgets}
                            gridLayout={props.gridLayout}
                            incorrectlyConfiguredDashboards={
                                incorrectlyConfiguredDashboards
                            }
                            isActiveTab={
                                props.activeTab === editorTabs.widgetLibrary
                            }
                            onAdd={props.onAdd}
                            setDraggingWidget={props.setDraggingWidget}
                        />
                        {renderWidgetEditor()}
                    </div>
                </VerticalFlex>
            </div>
        </div>
    );
}

EditorDrawer.propTypes = {
    activeTab: PropTypes.string.isRequired,
    availableWidgets: PropTypes.instanceOf(Array).isRequired,
    dashboardTimeAndPrecision: PropTypes.instanceOf(Object).isRequired,
    deleteWidget: PropTypes.func.isRequired,
    drawerCollapsed: PropTypes.bool.isRequired,
    gridLayout: PropTypes.instanceOf(Array),
    onAdd: PropTypes.func.isRequired,
    selectedWidget: PropTypes.instanceOf(Object),
    setActiveTab: PropTypes.func.isRequired,
    setDraggingWidget: PropTypes.func.isRequired,
    setErrorWidgetIds: PropTypes.func.isRequired,
    toggleDrawer: PropTypes.func.isRequired,
    updateWidget: PropTypes.func.isRequired,
};

EditorDrawer.defaultProps = {
    selectedWidget: {},
};
